const mapKey = 'D2MBZ-UNXKL-LHZPE-ER57V-RIEKQ-K2FMU'
// 门店类型
const storeTypeList = ['美滋滋', '蛮碗香', '长安大东家', '虎头张', '代运营', '其他']

// 品牌列表（用于筛选）
const brandList = ['美滋滋', '蛮碗香', '长安大东家', '虎头张', '代运营']

// 门店状态列表（用于筛选）
const storeStatusFilterList = [
  { label: '锁商圈', value: 0 },
  { label: '筹建中', value: 1 },
  { label: '营业中', value: 2 }
]

// 门店类型颜色
const storeTypeColorList = ['primary', 'warning', 'danger', 'danger', 'success', 'info']

// 服务方式
const serviceTypeList = ['双平台', '单平台']

// 来源
const fromList = ['王老板', '吴嫚嫚', '400', '抖音投流', '快手投流', '腾讯投流', '转介绍', '开分店', '投流']

// 门店状态说明
const storeStatusList = ['未开始', '商圈锁定', '筹建中', '营业中', '已关闭']

// 收支类型
const feeTypeList = ['王老板', '吴嫚嫚', '400', '抖音投流', '快手投流', '腾讯投流', '转介绍', '开分店', '投流']

// 支付方式

const payTypeList = [
  '全款',
  '首款',
  '尾款',
  '续签款',
  '退款'
]

// 成交项目时的可选钱款类型
const payTypeListForNew = [
  '全款',
  '首款'
]

// 收款账号
const payAccountList = [
  '飞赢品牌企业微信',
  '飞赢品牌支付宝',
  '飞赢品牌对公账户',

  '餐赢管家企业微信',
  '餐赢管家支付宝',
  '餐赢管家对公账户',

  '餐赢品牌企业微信',
  '餐赢品牌支付宝',
  '餐赢品牌对公账户',

  '飞鸟餐赢餐饮企业微信',
  '飞鸟餐赢餐饮支付宝',
  '飞鸟餐赢餐饮对公账户',

  '共创有未企业微信',
  '共创有未支付宝',
  '共创有未对公账户',

  '深圳伍陆七聚合码',
  '深圳伍陆七对公账户',

  '聚营餐饮企业微信',
  '聚营餐饮支付宝',
  '聚营餐饮对公账户',
  '聚营餐饮聚合码',

  '西安加赢餐饮管理有限公司企业微信',
  '西安加赢餐饮管理有限公司支付宝',
  '西安加赢餐饮管理有限公司对公账户'
]

// 门店背景的初始值
const additionalInfo = () => {
  return {
    评估单量: '',
    客户签约代表: '',
    联系电话: '',
    店铺面积: '',
    店铺电力: '',
    店铺下水: '',
    燃气: '',
    运费: '',
    餐饮经验: '',
    是否多开: '',
    是否二店: '',
    是否翻新: '',
    商圈已测: '',
    车尾交接: '',
    情况说明: ''
  }
}

// 省份列表
const provinceList = [
  '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
  '辽宁省', '吉林省', '黑龙江省',
  '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
  '河南省', '湖北省', '湖南省',
  '广东省', '广西壮族自治区', '海南省',
  '重庆市', '四川省', '贵州省', '云南省', '西藏自治区',
  '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区',
  '台湾省', '香港特别行政区', '澳门特别行政区'
]

// 冻货仓库列表
const warehouseList = [
  '济南冻货仓', '郑州冻货仓', '成都冻货仓', '重庆冻货仓', '西安冻货仓',
  '武汉冻货仓', '北京冻货仓', '广州冻货仓', '南京冻货仓', '杭州冻货仓'
]

// 大区列表
const areaList = ['华北区', '东北区', '华东区', '华中区', '华南区', '西南区', '西北区', '台湾区', '其他']

// 根据省份直辖市返回大区名称,如上海市返回华东区
const getAreaName = (province) => {
  // 去除省/市/自治区后缀
  const provinceName = province.replace(/(省|市|自治区|特别行政区|壮族自治区|维吾尔自治区|回族自治区)$/g, '')

  switch (provinceName) {
    case '北京':
    case '天津':
    case '河北':
    case '山西':
    case '内蒙古':
      return '华北区'
    case '辽宁':
    case '吉林':
    case '黑龙江':
      return '东北区'
    case '上海':
    case '江苏':
    case '浙江':
    case '安徽':
    case '福建':
    case '江西':
    case '山东':
      return '华东区'
    case '河南':
    case '湖北':
    case '湖南':
      return '华中区'
    case '广东':
    case '广西':
    case '海南':
    case '香港':
    case '澳门':
      return '华南区'
    case '重庆':
    case '四川':
    case '贵州':
    case '云南':
    case '西藏':
      return '西南区'
    case '陕西':
    case '甘肃':
    case '青海':
    case '宁夏':
    case '新疆':
      return '西北区'
    case '台湾':
      return '台湾区'
    default:
      return '其他'
  }
}

// 招商部门职位
const zhaoshangJobList = ['员工', '主管', '总监']

// 运营职位
const yunyingJobList = ['总监', '运营主管', 'I阶运营师', 'II阶运营师']

// 筹建职位
const dudaoJobList = ['督导主管', '筹建督导', '营运督导', '建店专员', '平面设计', '空间设计']

// 全局员工管理可选职位（三部门职位合并去重，配合 allow-create 支持公用部门自定义职位）
const systemJobList = ['总经理', ...new Set([...zhaoshangJobList, ...yunyingJobList, ...dudaoJobList])]

// 招商续签提成比例
const renewCommissionRate = 0.06

// 商圈范围默认值（公里）
const rangeDefaults = {
  美滋滋: 4,
  蛮碗香: 4,
  长安大东家: 3,
  虎头张: 5,
  代运营: 5
}

module.exports = {
  zhaoshangJobList,
  yunyingJobList,
  dudaoJobList,
  systemJobList,
  storeTypeList,
  storeTypeColorList,
  serviceTypeList,
  fromList,
  storeStatusList,
  feeTypeList,
  payTypeList,
  payTypeListForNew,
  additionalInfo,
  payAccountList,
  getAreaName,
  provinceList,
  warehouseList,
  areaList,
  brandList,
  storeStatusFilterList,
  mapKey,
  rangeDefaults,
  renewCommissionRate
}
